import { FileDto, GetFileParams, UploadFileParams } from '@app/models/file';

import { InternalApiRequest } from '@app/services/api-request/';

export abstract class FileApi {
  static async getFile({ id, isAttachment, isPublic, cropSize }: GetFileParams) {
    return InternalApiRequest.get<Blob>(`/${isPublic ? 'public' : 'private'}/files/${id}`, {
      params: {
        isAttachment,
        cropSize,
      },
      responseType: 'blob',
    });
  }

  static async uploadFile({ formData, config, isPublic }: UploadFileParams) {
    return await InternalApiRequest.post<FileDto>('/private/files', formData, {
      ...config,
      params: { ...config?.params, isPublic },
    });
  }

  static async deleteFile(fileId: string) {
    return await InternalApiRequest.delete(`/private/files/${fileId}`);
  }
}
